
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyBarrelTShape as ObiBuoyBarrelTShapeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-barrel-t-shape.js';
 
 
 

 
 export const ObiBuoyBarrelTShape = createComponent({
   react: React,
   tagName: 'obi-buoy-barrel-t-shape',
   elementClass: ObiBuoyBarrelTShapeElement,
   events: {
     
   }
  });
 
 